module.exports = __webpack_public_path__ + "img/third.b869a56a.png";